export default {
  "site.name": "红桃视频",
  "site.slogan": "免费高清在线观看平台",
  "site.description": "红桃视频免费在线观看，海量高清影视资源任意播放，无需注册即可畅享最新电影、电视剧、综艺节目。",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索影片...",
  "home.hero.title": "红桃视频免费在线观看",
  "home.hero.subtitle": "海量高清影视资源，无需注册，随时畅享",
  "home.hero.cta": "立即观看",
  "home.hot": "热门推荐",
  "home.new": "最新更新",
  "home.all": "全部影片",
  "home.viewAll": "查看全部",
  "home.views": "次播放",
  "home.rating": "评分",
  "home.episode": "更新至",
  "category.title": "分类浏览",
  "category.all": "全部",
  "category.movie": "电影",
  "category.tv": "电视剧",
  "category.variety": "综艺",
  "category.anime": "动漫",
  "category.documentary": "纪录片",
  "category.short": "短视频",
  "category.total": "共",
  "category.videos": "部影片",
  "article.back": "返回",
  "article.director": "导演",
  "article.actors": "主演",
  "article.region": "地区",
  "article.year": "年份",
  "article.duration": "时长",
  "article.rating": "评分",
  "article.views": "播放量",
  "article.tags": "标签",
  "article.description": "剧情简介",
  "article.related": "相关推荐",
  "article.watchNow": "立即播放",
  "about.title": "关于红桃视频",
  "about.intro": "品牌介绍",
  "about.intro.content": "红桃视频是一个致力于为用户提供免费高清影视在线观看服务的平台。我们汇聚了海量优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，让每一位用户都能在这里找到自己喜欢的影片。",
  "about.mission": "我们的使命",
  "about.mission.content": "让每一个人都能平等地享受优质影视内容。我们坚持免费、高清、无广告的理念，持续为用户提供最佳的观影体验。",
  "about.reputation": "用户口碑",
  "about.reputation.content": "红桃视频自上线以来，已累计服务超过5000万用户，日均活跃用户超过300万。我们以流畅的播放体验和丰富的资源库赢得了用户的广泛好评。",
  "about.contact": "联系我们",
  "about.contact.email": "电子邮箱",
  "about.contact.address": "公司地址",
  "about.contact.phone": "客服电话",
  "footer.copyright": "版权所有",
  "footer.terms": "服务条款",
  "footer.privacy": "隐私政策",
  "footer.help": "帮助中心",
  "breadcrumb.home": "首页",
  "seo.keywords": "红桃视频免费在线观看,红桃视频高清免费,红桃视频在线播放,红桃视频最新资源,免费在线观看高清影视,红桃视频手机版,红桃视频无广告观看",
};